import { useApi } from "gf-ui";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { apiQuestionario } from "../../libQuestionario/api/apiQuestionario";
import NuovaScheda from "../../libQuestionario/components/NuovaScheda";

const QNuovaScheda = ({ homeRoute, root, headerComponent }) => {
  const { ID_MA_MODELLO } = useParams()  
  const navigate = useNavigate()  
  const _apiQuestionario = useApi(apiQuestionario, null, root)
  const shouldInit = useRef(true)
  const [scheda, setScheda] = useState(null)
  const [risultato, setRisultato] = useState(null)

  const getSchedaNuova = useCallback(() => {
    _apiQuestionario.fnSchedaNuova(res => {
      setScheda(res.scheda)
    }, { ID_MODELLO: ID_MA_MODELLO })
  }, [ID_MA_MODELLO, _apiQuestionario])

  const onSalvaRisposte = (params) => {    

    _apiQuestionario.fnSalvaRisposte((res) => {            

      let _res = { ...res }

      if(_res.SCHEDA){
        setScheda(JSON.parse(_res.SCHEDA))
        delete _res.scheda
      }      

      setRisultato(_res)
      
      _apiQuestionario.setFixedParams({        
        ID_SCHEDA: _res.ID_SCHEDA
      })
    }, params);
  }

  const onAnnulla = () => {
    setScheda(null)
    navigate(`${homeRoute}`)
  }

  useEffect(() => {
    if (shouldInit.current && _apiQuestionario) {
      shouldInit.current = false
      getSchedaNuova()
    }
  }, [_apiQuestionario, getSchedaNuova])

  return <>
    {headerComponent}
    <div className="bg-light">
      {scheda && <NuovaScheda scheda={scheda}
        onAnnulla={onAnnulla}
        onSalvaRisposte={onSalvaRisposte}
        onUpdateScheda={setScheda}
        risultato={risultato}
        rottaPaginaRisultato={`${homeRoute}/risultato`}
        rottaHome={`${homeRoute}`}
        apiClient={_apiQuestionario}
      />
      }
    </div>
  </>
}

export default QNuovaScheda